import React from 'react';
import OTGreyCard from '../../../components/containers/cards/OTGreyCard';
import { Container } from '../../../components/view/FormBuilderStatusesView';
import _DeleteIcon from '@material-ui/icons/Delete';
import SelectEngine from '../../../components/engine/SelectEngine';
import BackButton from '../../../components/BackButton';
import Button from '../../../components/Button';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import { SimpleFlexContainer } from '../../../components/layouts/ng-layouts/Containers';
import InputBase from '../../../components/form/InputBase';
import Labeler from '../../../components/Labeler';
import ConditionsQueryBuilderEngine from '../../../components/conditions-query-builder/engine/ConditionsQueryBuilderEngine';
import UsersInputBoxEngine from '../../../components/engine/UsersInputBoxEngine';
import { Options } from '../../../components/conditions-query-builder/view/ConditionsQueryBuilderView';
import _InfoIcon from '@material-ui/icons/Info';
import { Tooltip } from '@material-ui/core';

const SectionContainerCSS = `
    margin-top: 0.8rem;
`;

const SectionContainer = props => {
  return <OTGreyCard $css={SectionContainerCSS} {...props} />;
};

const Row = styled(SimpleFlexContainer)`
  column-gap: 5rem;
`;

const TopControls = styled.div`
  display: flex;
`;

const PermissionsHeader = styled.div`
  margin: 0.8rem 0;
`;

const WizardTitle = styled.h2`
  margin: 0.8rem 1rem;
  font-size: 18px;
  font-weight: 600;
`;

const GroupNameInput = styled(InputBase)`
  && {
    width: 300px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 0 0 0;
`;

const InfoIcon = styled(_InfoIcon)`
  margin-left: 1rem;
  vertical-align: middle;
`;

const AdminGroupWizardView = props => {
  const t = useTranslations();
  return (
    <Container>
      <TopControls>
        <BackButton onClick={props.onCancel} size="small" />
        <WizardTitle>
          {t('form-builder.admins.add_section_admin')}
          <Tooltip title={t('form-builder.admins.warning_one')}>
            <InfoIcon />
          </Tooltip>
        </WizardTitle>
      </TopControls>
      <SectionContainer>
        <Row $row>
          <Labeler
            label={t('form-builder.admins.name_of_admin_group')}
            customCSS="margin-bottom: 0.5rem; font-size: 16px; font-weight: 400;"
          >
            <GroupNameInput
              placeholder={t('form-builder.admins.group_name_placeholder_text')}
              value={props.groupName}
              variant="outlined"
              size="small"
              onChange={event => {
                props.onGroupNameChanged(event);
              }}
            />
          </Labeler>
          <Labeler
            label={t('form-builder.admins.select_users')}
            customCSS="margin-bottom: 0.5rem; font-size: 16px; font-weight: 400;"
          >
            <UsersInputBoxEngine
              value={props.collaboratorValues}
              onChange={users => {
                props.onUsersChanged(users);
              }}
              filterOption={props.filterExistingCollaborators}
              customCSS="&&{width: 600px;}"
            />
          </Labeler>
        </Row>
      </SectionContainer>
      <SectionContainer>
        <PermissionsHeader>
          {t('form-builder.admins.group_permissions')}
        </PermissionsHeader>
        <div>
          {t('form-builder.admins.group_can_view')}
          <SelectEngine
            placeholder={t('form-builder.groups.all')}
            value={props.groupIds}
            onChange={props.onGroupsChanged}
            options={props.groupOptions}
            allowMultiSelect
            customCSS="&&{ margin-left: 0.8rem;}"
          />
        </div>
        <ConditionsQueryBuilderEngine
          backEndConditions={props.query}
          form={props.form}
          update={props.updateQuery}
          filter={[Options.RESPONSIBLE_ADMIN, Options.DATE_RANGE]}
          useSpacers
        />
      </SectionContainer>
      <SectionContainer>
        <Labeler
          label={t('form-builder.admins.select_sections_for_group')}
          customCSS="margin-bottom: 0.5rem; font-size: 16px; font-weight: 400;"
        >
          <SelectEngine
            placeholder={t('form-builder.admins.select_sections')}
            value={props.chosenFields}
            options={props.adminFieldTitles}
            onChange={props.onFieldsChanged}
            searchable
            allowMultiSelect
            customCSS="&&{width:500px;}"
          />
        </Labeler>
      </SectionContainer>

      <ButtonsContainer>
        <Button disabled={props.isSaveBtnDisabled()} onClick={props.onSave}>
          {t('form-builder.admins.confirm')}
        </Button>
      </ButtonsContainer>
    </Container>
  );
};

export default AdminGroupWizardView;
